import Stack from '@mui/material/Stack'

import { useUsageSummary } from '@/features/usage/useUsageSummary'
import PlanUsageActivityHeatmap from './PlanUsageActivityHeatmap'
import PlanUsagePlanAndUpgradeRow from './PlanUsagePlanAndUpgradeRow'
import PlanUsageTokenAllowanceCard from './PlanUsageTokenAllowanceCard'

/**
 * Settings ▸ Overview — plan tiles, real token usage, and an activity heatmap.
 * Visual tokens follow the product shell; typography uses the global MUI theme.
 */
export default function PlanUsageSettingsContent() {
  const { data, isLoading } = useUsageSummary()

  return (
    <Stack spacing={1} sx={{ width: '100%', mt: '14px', alignItems: 'stretch' }}>
      <PlanUsagePlanAndUpgradeRow />
      <PlanUsageTokenAllowanceCard
        totals={data?.totals}
        configured={data?.configured}
        isLoading={isLoading}
      />
      <PlanUsageActivityHeatmap series={data?.series} />
    </Stack>
  )
}
